import React from 'react';
import { Building2, Target, Eye, Award } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-neutral-800 mb-6">
            {t('about-title')}
          </h2>
          <p className="text-xl text-neutral-600 max-w-3xl mx-auto">
            {t('about-subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Company History */}
          <div className="space-y-6">
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <Building2 className="h-8 w-8 text-primary-500" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-neutral-800 mb-3">{t('about-history-title')}</h3>
                <p className="text-neutral-600 leading-relaxed">
                  {t('about-history-text')}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <Target className="h-8 w-8 text-primary-500" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-neutral-800 mb-3">{t('about-mission-title')}</h3>
                <p className="text-neutral-600 leading-relaxed">
                  {t('about-mission-text')}
                </p>
              </div>
            </div>

            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0">
                <Eye className="h-8 w-8 text-primary-500" />
              </div>
              <div>
                <h3 className="text-2xl font-semibold text-neutral-800 mb-3">{t('about-vision-title')}</h3>
                <p className="text-neutral-600 leading-relaxed">
                  {t('about-vision-text')}
                </p>
              </div>
            </div>
          </div>

          {/* CO2 Neutral Technologies */}
          <div className="bg-neutral-50 rounded-2xl p-8">
            <h3 className="text-2xl font-semibold text-neutral-800 mb-6">
              {t('about-technologies-title')}
            </h3>
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
                <span className="text-neutral-700">{t('about-tech-1')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
                <span className="text-neutral-700">{t('about-tech-2')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
                <span className="text-neutral-700">{t('about-tech-3')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
                <span className="text-neutral-700">{t('about-tech-4')}</span>
              </div>
              <div className="flex items-center space-x-3">
                <div className="w-3 h-3 bg-primary-500 rounded-full"></div>
                <span className="text-neutral-700">{t('about-tech-5')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Achievements */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="text-center p-6 bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl">
            <Award className="h-12 w-12 text-primary-500 mx-auto mb-4" />
            <h4 className="text-xl font-semibold text-neutral-800 mb-2">{t('about-achievement-1-title')}</h4>
            <p className="text-neutral-600">{t('about-achievement-1-text')}</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl">
            <Award className="h-12 w-12 text-primary-500 mx-auto mb-4" />
            <h4 className="text-xl font-semibold text-neutral-800 mb-2">{t('about-achievement-2-title')}</h4>
            <p className="text-neutral-600">{t('about-achievement-2-text')}</p>
          </div>
          <div className="text-center p-6 bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl">
            <Award className="h-12 w-12 text-primary-500 mx-auto mb-4" />
            <h4 className="text-xl font-semibold text-neutral-800 mb-2">{t('about-achievement-3-title')}</h4>
            <p className="text-neutral-600">{t('about-achievement-3-text')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About; 